// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>12</span>&nbsp;&nbsp;Because of my integrity you uphold me&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and will set me before your face for ever.<br> </p> </div></div>";
// Exports
module.exports = code;